module.exports = new __parcel__URL__("sk_3.356463f5.png").toString();